/**
 * Hook · roster minimal de usuarios asignables a una tarea.
 *
 * Wrap del RPC core.list_assignable_users. Cache 5 min (es un roster que
 * cambia poco). Devuelve AssignableUser[] listos para alimentar pickers.
 */
import { useQuery } from '@tanstack/react-query';

import { listAssignableUsers, type AssignableUser } from '../api/assignableUsers';

export const ASSIGNABLE_USERS_KEY = ['core', 'tasks', 'assignable-users'] as const;

export function useAssignableUsers() {
  return useQuery<AssignableUser[]>({
    queryKey: ASSIGNABLE_USERS_KEY,
    queryFn: listAssignableUsers,
    staleTime: 5 * 60_000,
  });
}
